<div class="p-6 space-y-8">

    <!-- HEADER -->
    <div class="flex items-start justify-between gap-4">
        <div>
            <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Configuración</h1>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Datos de tu empresa y series documentales.</p>
        </div>
        <button type="button" (click)="saveCompany()" [disabled]="savingCompany || loadingCompany"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            @if (savingCompany) {
            <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            Guardando…
            } @else {
            Guardar empresa
            }
        </button>
    </div>

    <!-- EMPRESA -->
    @if (loadingCompany) {
    <div class="text-center py-10 text-gray-500 dark:text-gray-400 text-sm">Cargando datos de la empresa…</div>
    } @else {
    <div class="bg-white dark:bg-white/3 rounded-2xl border border-gray-200 dark:border-gray-800">

        <!-- Tabs -->
        <div class="flex border-b border-gray-200 dark:border-gray-800 px-6">
            @for (tab of ([{id:'general',label:'General'},{id:'sunat',label:'SUNAT'},{id:'certificate',label:'Certificado'}]); track tab.id) {
            <button type="button" (click)="companyTab = $any(tab.id)"
                class="px-4 py-3 text-sm font-medium border-b-2 transition-colors -mb-px"
                [class]="companyTab === tab.id
                    ? 'border-brand-500 text-brand-600 dark:text-brand-400'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'">
                {{ tab.label }}
                @if (companyFormSubmitted && tab.id === 'general' && companyFormError) {
                <span class="ml-1 w-2 h-2 rounded-full bg-error-500 inline-block"></span>
                }
                @if (companyFormSubmitted && tab.id === 'sunat' && sunatFormError) {
                <span class="ml-1 w-2 h-2 rounded-full bg-error-500 inline-block"></span>
                }
            </button>
            }
        </div>

        <div class="p-6">

            <!-- ERROR BANNER -->
            @if (companyFormSubmitted && (companyFormError || sunatFormError)) {
            <div class="mb-5 px-4 py-3 rounded-lg bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/30 text-sm text-error-700 dark:text-error-400">
                {{ companyFormError || sunatFormError }}
            </div>
            }

            <!-- TAB: GENERAL -->
            @if (companyTab === 'general') {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">

                <div>
                    <app-label>RUC</app-label>
                    <app-input-field [value]="ruc" [disabled]="true" />
                </div>

                <div>
                    <app-label>Razón social *</app-label>
                    <app-input-field placeholder="Ej: MI EMPRESA S.A.C." [(value)]="businessName" maxlength="200" />
                </div>

                <div>
                    <app-label>Nombre comercial</app-label>
                    <app-input-field placeholder="Ej: Mi Empresa" [(value)]="tradeName" maxlength="200" />
                </div>

                <div class="sm:col-span-2">
                    <app-label>Dirección *</app-label>
                    <app-input-field placeholder="Dirección fiscal completa" [(value)]="address" maxlength="500" />
                </div>

                <div class="sm:col-span-2">
                    <app-label>Ubigeo *</app-label>
                    <app-ubigeo-picker [ubigeos]="allUbigeos" [loading]="loadingUbigeos"
                        [value]="ubigeo" (valueChange)="onUbigeoChange($event)"
                        placeholder="Seleccionar ubigeo..."></app-ubigeo-picker>
                </div>

                <div>
                    <app-label>Departamento</app-label>
                    <app-input-field [value]="ubigDepartment" [disabled]="true" />
                </div>
                <div>
                    <app-label>Provincia</app-label>
                    <app-input-field [value]="ubigProvince" [disabled]="true" />
                </div>
                <div>
                    <app-label>Distrito</app-label>
                    <app-input-field [value]="ubigDistrict" [disabled]="true" />
                </div>

                <!-- Divider -->
                <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-1 mt-1">
                    <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Contacto</p>
                </div>

                <div>
                    <app-label>Teléfono</app-label>
                    <app-input-field placeholder="Ej: 999999999" [(value)]="phone" maxlength="30" />
                </div>

                <div>
                    <app-label>Correo electrónico</app-label>
                    <app-input-field placeholder="contacto@empresa.com" [(value)]="email" maxlength="150" />
                </div>

                <div class="sm:col-span-2">
                    <app-label>Sitio web</app-label>
                    <app-input-field placeholder="https://empresa.com" [(value)]="website" maxlength="200" />
                </div>

                <!-- Divider -->
                <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-1 mt-1">
                    <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Logo</p>
                </div>

                <div class="sm:col-span-2">
                    <p class="text-xs text-gray-400 dark:text-gray-500 mb-1">Recomendado: 3500 × 2500 px (PNG o JPG).</p>
                    <div class="flex flex-col gap-2">
                        <input type="file" accept="image/*" (change)="onLogoFileChange($event)"
                            class="block w-full text-sm text-gray-500 dark:text-gray-400 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-brand-50 file:text-brand-700 dark:file:bg-brand-900/30 dark:file:text-brand-400 hover:file:bg-brand-100 cursor-pointer" />
                        @if (logoFile) {
                        <p class="text-xs text-gray-500 dark:text-gray-400">{{ logoFile.name }} ({{ (logoFile.size / 1024).toFixed(1) }} KB)</p>
                        }
                        <app-input-field placeholder="O pega una URL de imagen…" [(value)]="logoUrl" />
                        @if (logoUrl && !logoFile) {
                        <img [src]="logoUrl" alt="Logo" class="h-12 w-auto object-contain rounded" />
                        }
                    </div>
                </div>

                <!-- Registro -->
                @if (createdAt) {
                <div class="sm:col-span-2 text-xs text-gray-400 dark:text-gray-500">
                    Registrada el {{ createdAt | date:'dd/MM/yyyy HH:mm' }}
                </div>
                }

            </div>
            }

            <!-- TAB: SUNAT -->
            @if (companyTab === 'sunat') {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">

                <div>
                    <app-label>Código de establecimiento *</app-label>
                    <app-input-field placeholder="Ej: 0000" [(value)]="sunatEstablishmentCode" maxlength="10" />
                </div>

                <div>
                    <app-label>Cuenta detracciones</app-label>
                    <app-input-field placeholder="Ej: 00-123456" [(value)]="sunatDetractionAccount" maxlength="20" />
                </div>

                <!-- Toggles -->
                <div class="sm:col-span-2 flex flex-col gap-3">
                    <label class="flex items-center justify-between p-3 rounded-xl border border-gray-200 dark:border-gray-700 cursor-pointer">
                        <div>
                            <p class="text-sm font-medium text-gray-700 dark:text-gray-200">Modo producción</p>
                            <p class="text-xs text-gray-400 mt-0.5">Activa el envío real a SUNAT. En Beta se usan servidores de prueba.</p>
                        </div>
                        <div class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" [(ngModel)]="sunatProduction" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:ring-2 peer-focus:ring-brand-300 dark:peer-focus:ring-brand-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-brand-500"></div>
                        </div>
                    </label>
                    <label class="flex items-center justify-between p-3 rounded-xl border border-gray-200 dark:border-gray-700 cursor-pointer">
                        <div>
                            <p class="text-sm font-medium text-gray-700 dark:text-gray-200">Ley de Amazonía</p>
                            <p class="text-xs text-gray-400 mt-0.5">Aplica beneficios tributarios de la Ley de Amazonia en los documentos.</p>
                        </div>
                        <div class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" [(ngModel)]="sunatAmazoniaLaw" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:ring-2 peer-focus:ring-brand-300 dark:peer-focus:ring-brand-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-brand-500"></div>
                        </div>
                    </label>
                </div>

                <!-- Divider -->
                <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-1 mt-1">
                    <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Credenciales secundarias</p>
                </div>

                <div>
                    <app-label>Usuario secundario</app-label>
                    <app-input-field placeholder="Usuario SUNAT" [(value)]="sunatSecondaryUser" maxlength="50" />
                </div>

                <div>
                    <app-label>Clave usuario secundario</app-label>
                    <app-input-field type="password" placeholder="Dejar vacío para no cambiar" [(value)]="sunatSecondaryUserPassword" maxlength="100" />
                </div>

                <div>
                    <app-label>Usuario guía de remisión</app-label>
                    <app-input-field placeholder="Usuario guía" [(value)]="sunatGuideId" maxlength="50" />
                </div>

                <div>
                    <app-label>Clave guía de remisión</app-label>
                    <app-input-field type="password" placeholder="Dejar vacío para no cambiar" [(value)]="sunatGuidePassword" maxlength="100" />
                </div>

                <!-- Divider -->
                <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-1 mt-1">
                    <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Ubicación SUNAT</p>
                </div>

                <div>
                    <app-label>Departamento</app-label>
                    <app-input-field [value]="ubigDepartment" [disabled]="true" />
                </div>
                <div>
                    <app-label>Provincia</app-label>
                    <app-input-field [value]="ubigProvince" [disabled]="true" />
                </div>
                <div>
                    <app-label>Distrito</app-label>
                    <app-input-field [value]="ubigDistrict" [disabled]="true" />
                </div>

            </div>
            }

            <!-- TAB: CERTIFICADO -->
            @if (companyTab === 'certificate') {
            <div class="space-y-5">

                <!-- Estado -->
                <div class="flex items-start gap-3 p-4 rounded-xl border"
                    [class]="sunatCertificateLoaded
                        ? 'border-success-200 bg-success-50 dark:border-success-800 dark:bg-success-900/20'
                        : 'border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-white/3'">
                    @if (sunatCertificateLoaded) {
                    <svg class="w-5 h-5 text-success-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    <div>
                        <p class="text-sm font-medium text-success-700 dark:text-success-300">Certificado digital cargado</p>
                        <p class="text-xs text-success-600 dark:text-success-400">Sube un nuevo archivo .pfx para reemplazarlo.</p>
                    </div>
                    } @else {
                    <svg class="w-5 h-5 text-gray-400 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    <div>
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Sin certificado cargado</p>
                        <p class="text-xs text-gray-500 dark:text-gray-400">Sube un archivo .pfx para habilitar la firma digital.</p>
                    </div>
                    }
                </div>

                <div>
                    <app-label>Archivo de certificado (.pfx)</app-label>
                    <input type="file" accept=".pfx,.p12" (change)="onPfxFileChange($event)"
                        class="block w-full text-sm text-gray-500 dark:text-gray-400 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-brand-50 file:text-brand-700 dark:file:bg-brand-900/30 dark:file:text-brand-400 hover:file:bg-brand-100 cursor-pointer" />
                    @if (pfxFile) {
                    <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ pfxFile.name }} ({{ (pfxFile.size / 1024).toFixed(1) }} KB)</p>
                    }
                </div>

                <div>
                    <app-label>Contraseña del certificado</app-label>
                    <app-input-field type="password" placeholder="Contraseña del archivo .pfx" [(value)]="pfxPassword" />
                </div>

            </div>
            }

        </div>
    </div>
    }

    <!-- TIPO DE CAMBIO -->
    <!-- <div class="bg-white dark:bg-white/3 rounded-2xl border border-gray-200 dark:border-gray-800 p-6">
        <h2 class="text-sm font-bold tracking-wide text-gray-700 dark:text-gray-300 uppercase mb-4">Tipo de cambio</h2>
        <div class="flex items-center justify-between p-4 rounded-xl bg-gray-50 dark:bg-white/3 border border-gray-100 dark:border-gray-800">
            <div>
                <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Tipo de cambio de hoy</p>
                @if (todayRate) {
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    Compra: <span class="font-semibold text-gray-700 dark:text-gray-200">S/ {{ todayRate.purchase | number:'1.3-3' }}</span>
                    &nbsp;·&nbsp;
                    Venta: <span class="font-semibold text-gray-700 dark:text-gray-200">S/ {{ todayRate.sale | number:'1.3-3' }}</span>
                </p>
                } @else {
                <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Consulta y registra el TC del día actual desde SBS.</p>
                }
            </div>
            <button type="button" (click)="updateTodayRate()" [disabled]="tcTodayLoading"
                class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                @if (tcTodayLoading) {
                <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Actualizando…
                } @else {
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Actualizar hoy
                }
            </button>
        </div>
    </div> -->

</div>
